import React from 'react';
import IntroductionPanel from '../modules/IntroductionPanel';
import SkillConversationsPanel from '../modules/SkillConversationsPanel';
import CustomQuestionsPanel from '../modules/CustomQuestionsPanel';
import ExercisePanel from '../modules/ExercisePanel';
import ResumePortionPanel from '../modules/ResumePortionPanel';
import LanguageAssessmentPanel from '../modules/LanguageAssessmentPanel';

const PANEL_MAP = {
  'skill-conversations': SkillConversationsPanel,
  'custom-questions': CustomQuestionsPanel,
  'exercise': ExercisePanel,
  'resume-conversation': ResumePortionPanel,
  'language-assessment': LanguageAssessmentPanel,
};

export default function ModuleDetailsPanel({ selected, openingPhrase, setOpeningPhrase, onUpdate, visible = true }) {
  let content = null;
  if (selected?.type === 'introduction') {
    content = <IntroductionPanel value={openingPhrase} onChange={setOpeningPhrase} />;
  } else {
    const Panel = PANEL_MAP[selected?.type];
    if (Panel) content = <Panel module={selected} onChange={onUpdate} />;
  }

  return (
    <div className={`${visible ? 'flex' : 'hidden'} lg:flex flex-col p-4 md:p-6 overflow-y-auto zara-scroll`}>
      <div className="flex-1">{content}</div>
    </div>
  );
}
